// extracted by mini-css-extract-plugin
export default {"liveStreamSection":"LiveStreamPaperSection_liveStreamSection__JvBk6"};